import ApplicationAdapter from 'volta/_pods/application/adapter';
import type ModelRegistry from "ember-data/types/registries/model";

export default class SimulationTaskAdapter extends ApplicationAdapter {
  pathForType<K extends keyof ModelRegistry>(_modelName: K): string {
    return 'simulations/tasks';
  }
}
